module.exports = __webpack_public_path__ + "assets/cc/PADCEV_3EU_Booth_VO_01.vtt";